export default __webpack_public_path__ + "static/media/ic-slider-polygon.05c55faa.svg";